// extracted by mini-css-extract-plugin
module.exports = {"editor":"MultiMentionTriggers_editor__3Hf1J","readOnly":"MultiMentionTriggers_readOnly__1HqS8"};